var _style, _g;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    @keyframes rotation {\n      0% {\n        transform: rotate(0deg);\n      }\n      100% {\n        transform: rotate(360deg);\n      }\n    }\n    .content{\n      -webkit-animation: rotation 1s linear infinite;\n      animation: rotation 1s linear infinite;\n      -webkit-transform-origin: center;\n      -ms-transform-origin: center;\n      transform-origin: center;\n    }\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "content"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 2.4C5.40721 2.4 2.9 4.90721 2.9 8C2.9 11.0928 5.40721 13.6 8.5 13.6C9.82433 13.6 11.0413 13.1403 12 12.3718L13.5 14.2454C12.1304 15.3433 10.3919 16 8.5 16C4.08172 16 0.5 12.4183 0.5 8C0.5 3.58172 4.08172 0 8.5 0C11.4611 0 14.0465 1.60879 15.4297 4L13.3343 5.17158C12.362 3.51342 10.561 2.4 8.5 2.4Z",
    fill: "url(#paint0_linear_3297_2489)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3297_2489",
    x1: 13,
    y1: -1.5,
    x2: 14,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF0FF"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.4217098dcb4d736899ae094475e8f6ce.svg";
export { ForwardRef as ReactComponent };